export default {
  White: "#ffffff",
  PrimaryBlue: "#253746",
};
